export default {"src":"/_next/static/media/redpagos.34515d0c.svg","height":16,"width":79,"blurWidth":0,"blurHeight":0};